import React from 'react';
import { Button, useDisclosure, Icon, HStack } from '@chakra-ui/react';
import { FaPlay } from 'react-icons/fa';
import SessionFlowModal from './SessionFlowModal';
import {useAppData} from '../../store/dataStore';

const SessionFlowTrigger = ({ buttonText = "See How Sessions Work", ...buttonProps }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const { appData } = useAppData();
  const { studentsCount } = appData;

  return (
    <>
      <Button
        onClick={onOpen}
        leftIcon={<Icon as={FaPlay} />}
        {...buttonProps}
      >
        {buttonText}
      </Button>
      <SessionFlowModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};

export default SessionFlowTrigger;